export default "__VITE_ASSET__BMEjy1Tj__"